import styled from "styled-components"

const RendezVousActions = styled.div``

export { RendezVousActions }
